module.exports = __webpack_public_path__ + "static/media/H+K X-ray Script.5598ca4a.pdf";